(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["crews-recent-history"] && !Shopify.designMode) return;
  try {
    (() => {
  const item = document.querySelector('[data-crews-recent-product]');
  if (!item) return;
  try {
    const current = JSON.parse(item.textContent);
    const prior = JSON.parse(sessionStorage.getItem('crews_recent_v1') || '[]');
    const valid = Array.isArray(prior) ? prior.filter(x => typeof x === 'string' && /^[a-z0-9-]+$/.test(x)) : [];
    sessionStorage.setItem('crews_recent_v1', JSON.stringify([current.handle, ...valid.filter(x => x !== current.handle)].slice(0, 8)));
  } catch {}
})();
  } catch(e) { console.error(e); }
})();

})();
